import type { ComponentProps } from 'react';

import { TabsList, TabsTrigger } from '@shigo-ui/ui';
import { cn } from '@shigo-ui/ui/cn';

export function DashboardDetailsTabList({ className, ...props }: ComponentProps<typeof TabsList>) {
  return (
    <TabsList
      className={cn(
        'h-auto justify-start gap-6 overflow-x-auto rounded-none bg-transparent px-3 py-0',
        className,
      )}
      {...props}
    />
  );
}

export function DashboardDetailsTab({ className, ...props }: ComponentProps<typeof TabsTrigger>) {
  return (
    <TabsTrigger
      className={cn(
        'border-border data-[state=active]:text-foreground text-muted-foreground flex h-10 gap-2 rounded-none border-b-2 border-transparent bg-transparent px-0 text-[13px] font-semibold data-[state=active]:border-[var(--shigo-highlight)] data-[state=active]:bg-transparent data-[state=active]:shadow-none',
        className,
      )}
      {...props}
    />
  );
}
